import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import BannerVolcan from '../components/BannerVolcan';
import Sponsors from '../components/Sponsors';
import MenuVolcan from '../components/MenuVolcan';
import MenuVolcanRoutes from '../components/MenuVolcanRoutes';
import '../assets/styles/containers/SimpleSection.sass';

class SimpleSectionVolcan extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      data: {},
      slug: '',
      showSubmenu: false
    }
  }
  
  componentDidMount() {
    const {slug} = this.props.match.params;
    this.getData(slug);
  }

  componentWillReceiveProps(nextProps) {
    const {slug} = this.props.match.params;
    if(slug !== nextProps.match.params.slug) {
      this.getData(nextProps.match.params.slug);
    }
 }

  getData(slug) {
    fetch(`${process.env.REACT_APP_URL}/general-volcan/${slug}`)
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({data: res});
        this.getBannerFoto(slug);
        this.handleSubmenu(slug);
      },
      (error) => {
        this.setState({error: error});
      }
    )
    return;
  }

  getBannerFoto(slug) {
    switch (slug) {
      case 'conviertete-en-patrocinador':
        this.setState({slug: 'conviertete-en-patrocinador'});
        break;
      case 'informacion-de-la-expo':
        this.setState({slug: 'informacion-de-la-expo'});
        break;
      case 'precios-que-incluye':
        this.setState({slug: 'precios-que-incluye'});
        break;
      default:
        this.setState({slug: ''});
        break;
    }
  }

  handleSubmenu(slug) {
    const shouldShow = slug === 'carrera-volcan' || slug === 'travesia-paramo' || slug === 'travesia-bosque';
    this.setState({showSubmenu: shouldShow});
  }

  render() {
    const {data, showSubmenu} = this.state;
    const {content, sponsors} = data;
    return (
      <Layout>
        <>
          <BannerVolcan id={14} city="volcan" thumb="/volcan/logo_volcan.png" picture={this.state.slug === 'precios-que-incluye' ? '' : this.state.slug}/>
          <MenuVolcan />
          {showSubmenu && <MenuVolcanRoutes /> }
          <div className="row content-volcan">

            {ReactHtmlParser(content?.content_es)}

          </div>
          {sponsors &&
            <Sponsors
              customClass="--volcan"
              items={sponsors}
            />
          }
        </>
      </Layout>
    );
  }
}

export default SimpleSectionVolcan;
